import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { getConnectionId } from "utils/localStorageServices";
import { getEventService } from "services/events.service";
import { endedEventAccessRedirect } from "./endedEventAccessRedirect";

export async function viewerModeConnectionGuardLoader({
  params,
  request,
}: LoaderFunctionArgs) {
  const friendlyId = params.friendlyId;

  if (!friendlyId) {
    throw new Response("Event not found", { status: 404 });
  }

  const connectionId = getConnectionId();
  const linkId = new URL(request.url).searchParams.get("linkId");
  try {
    const event = await getEventService(friendlyId, {
      ...(connectionId ? { presentaConnectionId: connectionId } : {}),
    });
    const accessPath = endedEventAccessRedirect(event, linkId);
    if (accessPath) return redirect(accessPath);
  } catch {
    // Only a confirmed ended event enters offline access. Otherwise preserve
    // the existing live-view connection check, including non-event URLs.
  }

  if (!connectionId) {
    const query = new URLSearchParams();
    if (linkId) query.set("linkId", linkId);
    return redirect(`/join/${encodeURIComponent(friendlyId)}${query.toString() ? `?${query.toString()}` : ""}`);
  }

  return null;
}
